import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Ng2FlatpickrComponent} from './ng2-flatpickr.component';

@NgModule({
  imports: [CommonModule],
  declarations: [Ng2FlatpickrComponent],
  exports: [Ng2FlatpickrComponent]
})
export class Ng2FlatpickrModule {}
